import {Meta, MetaProvider, Title} from "@solidjs/meta";
import {RouteSectionProps} from "@solidjs/router";
import {ErrorBoundary, Suspense} from "solid-js";
import Error from "~/components/Error";
import Layout from "~/components/layout/Layout";
import UserProvider from "~/context/UserContext";
import PostHogProvider from "~/context/PostHogContext";
import PostHogIdentify from "~/components/posthog/PostHogIdentify";

export default function AppRoot(props: RouteSectionProps) {

    return (
        <ErrorBoundary fallback={Error}>
            <MetaProvider>
                <Title>Tag-Tails</Title>
                <Meta name="description" content="Get your smart pet tag today!"/>
                <Suspense>
                    <PostHogProvider>
                        <UserProvider>
                            <PostHogIdentify/>
                            <Layout>
                                {props.children}
                            </Layout>
                        </UserProvider>
                    </PostHogProvider>
                </Suspense>
            </MetaProvider>
        </ErrorBoundary>
    )
}

